import script from "./tablist.vue?vue&type=script&lang=ts&setup=true"
export * from "./tablist.vue?vue&type=script&lang=ts&setup=true"

import "./tablist.vue?vue&type=style&index=0&id=e207c8ce&lang=less&scoped=true"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e207c8ce"]])

export default __exports__